import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext, getLanguageDisplay } from '../../context/AppContext';
import { useLogo } from '../../hooks/useLogo';
import { useCmsText } from '../../hooks/useCmsText';

function MenuHamburger1({color}: {color?: string}) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			transform="rotate(0 0 0)"
			stroke={color}
		>
			<path
				d="M20 7.125L4 7.125C3.37868 7.125 2.875 6.62132 2.875 6C2.875 5.37868 3.37868 4.875 4 4.875L20 4.875C20.6213 4.875 21.125 5.37868 21.125 6C21.125 6.62132 20.6213 7.125 20 7.125ZM20 13.125L4 13.125C3.37868 13.125 2.875 12.6213 2.875 12C2.875 11.3787 3.37868 10.875 4 10.875L20 10.875C20.6213 10.875 21.125 11.3787 21.125 12C21.125 12.6213 20.6213 13.125 20 13.125ZM20 19.125L4 19.125C3.37868 19.125 2.875 18.6213 2.875 18C2.875 17.3787 3.37868 16.875 4 16.875L20 16.875C20.6213 16.875 21.125 17.3787 21.125 18C21.125 18.6213 20.6213 19.125 20 19.125Z"
				fill="#343C54"
			/>
		</svg>
	);
}

const getLogo = (base64: string | undefined) => {
	if (!base64) {
		return '/images/Vector.png';
	}
	return `data:image/png;base64,${base64}`;
}

const Header = () => {
	const { state, dispatch } = useAppContext();
	const navigate = useNavigate();
	const { renderText } = useCmsText();
	const [showMenu, setShowMenu] = useState(false);
	const [showDropdown, setShowDropdown] = useState(false);
	const [mobileDropdown, setMobileDropdown] = useState(false);

	const handleBackToStart = () => {
		if (state.partnerName) {
			navigate(`/?partner=${state.partnerName}`);
		} else {
			navigate('/');
		}
	};

	const selectedLanguage =
		state.languages.find((lang) => lang.code === state.selectedLanguage) ||
		state.languages[0];

	const handleSelectedLanguage = (code: string) => {
		dispatch({ type: 'SET_LANGUAGE', payload: code });
		setShowDropdown(false);
		setMobileDropdown(false);
	};

	const handleClick = () => {
		navigate('/');
	};

	const toggleMenu = () => {
		setShowMenu(!showMenu);
	};

	return (
		<header className="border-x border-y">
			<div className="container mx-auto px-6 py-5">
				<div className="flex items-center justify-between">
					<div
						onClick={handleBackToStart}
						className="flex items-center cursor-pointer"
					>
						<div className="mr-4 flex flex-row items-center">
							{/* <img
								width={'30'}
								height={'30'}
								src={getLogo(state.branding?.logo)}
								alt="Skjold"
								className="cursor-pointer"
							/> */}
							{/* <p className="mx-3 font-semibold text-lg" style={{color: state.branding?.fontColor}}>Skjold</p> */}
						</div>
					</div>

					{/* Desktop Navigation */}
					<div className="w-full hidden justify-between md:flex md:items-center md:justify-end">
						<a
							href="https://www.skjold.ai/om-oss-1"
							target="_blank"
							className="mx-10"
						>
							{renderText('banner_link1', 'Om oss')}
						</a>
						<a
							href="https://hjelp.skjold.ai/"
							target="_blank"
							className="mx-10"
						>
							{renderText('banner_link2', 'Hjelp?')}
						</a>
						<div className="relative mx-10">
							<div
								onClick={() => setShowDropdown(!showDropdown)}
								className="flex items-center cursor-pointer"
							>
								<span
									className="mr-2"
									style={{
										color: state.branding?.fontColor,
									}}
								>
									{getLanguageDisplay(selectedLanguage.code)}
								</span>
								{/* <GoChevronDown size={'1.3em'} /> */}
								<i
									className="lni lni-chevron-down"
									style={{
										color: state.branding?.fontColor,
									}}
								></i>
							</div>
							{showDropdown && (
								<div className="absolute top-full right-0 mt-2 w-48 bg-white shadow-lg rounded-md z-20">
									<ul>
										{state.languages.map((language, index) => (
											<li
												key={index}
												className="hover:bg-gray-100 px-4 py-2 flex items-center cursor-pointer"
												onClick={() => handleSelectedLanguage(language.code)}
											>
												<span className="ml-1" style={{color: state.branding?.fontColor}} >{getLanguageDisplay(language.code)}</span>
											</li>
										))}
									</ul>
								</div>
							)}
						</div>
					</div>

					{/* Mobile menu button */}
					<div className="md:hidden cursor-pointer" onClick={toggleMenu}>
						{/* <TbMenu2 size={'1.5em'} /> */}
						<MenuHamburger1 color={state.branding?.fontColor} />
					</div>
				</div>

				{/* Mobile menu */}
				{showMenu && (
					<div className="fixed top-0 left-0 w-full h-full bg-white z-10 overflow-y-auto">
						<div className="container mx-auto px-6 py-5 flex flex-col h-full">
						{/* Top bar */}
						<div className="flex items-center justify-between mb-6">
							<div
							className="flex items-center cursor-pointer"
							onClick={handleBackToStart}
							>
							<div className="mr-4 flex flex-row items-center">
								<img
								width={'30'}
								height={'30'}
								src="/images/Vector.png"
								alt="Skjold"
								className="cursor-pointer"
								/>
								<a className="mx-3 font-semibold text-lg cursor-pointer">
								Skjold
								</a>
							</div>
							</div>
							<div className="md:hidden cursor-pointer" onClick={toggleMenu}>
							<MenuHamburger1 color={state.branding?.fontColor} />
							</div>
						</div>

						{/* Language Selector (moved higher) */}
						<div className="relative border-b border-gray-200 pb-3 mb-4">
							<div
							onClick={() => setMobileDropdown(!mobileDropdown)}
							className="flex items-center justify-between cursor-pointer py-2"
							>
							<span
								className="font-medium text-lg"
								style={{ color: state.branding?.fontColor }}
							>
								{getLanguageDisplay(selectedLanguage.code)}
							</span>
							<i
								className={`lni lni-chevron-down transition-transform ${
								mobileDropdown ? 'rotate-180' : ''
								}`}
								style={{ color: state.branding?.fontColor }}
							></i>
							</div>

							{mobileDropdown && (
							<div className="absolute left-0 mt-2 w-full bg-white shadow-md rounded-lg border border-gray-100 z-20">
								<ul>
								{state.languages.map((language, index) => (
									<li
									key={index}
									className="hover:bg-gray-100 px-4 py-2 cursor-pointer text-center"
									onClick={() => {
										handleSelectedLanguage(language.code);
										setShowMenu(false);
									}}
									>
									<span
										style={{ color: state.branding?.fontColor }}
										className="font-medium"
									>
										{getLanguageDisplay(language.code)}
									</span>
									</li>
								))}
								</ul>
							</div>
							)}
						</div>

						{/* Navigation Links */}
						<div className="flex flex-col space-y-4">
							<a
							href="https://www.skjold.ai/om-oss-1"
							target="_blank"
							className="text-xl font-medium"
							>
							{renderText('banner_link1', 'Om oss')}
							</a>
							<a
							href="https://hjelp.skjold.ai/"
							target="_blank"
							className="text-xl font-medium"
							>
							{renderText('banner_link2', 'Hjelp?')}
							</a>
						</div>
						</div>
					</div>
					)}
			</div>
		</header>
	);
};

export default Header;
